(function () {
  const DESKTOP = 990;
  const BUFFER = 4; // tiny breathing room

  function init() {
    const nav = document.querySelector('.header__inline-menu');
    const ul  = nav && nav.querySelector('.list-menu--inline');
    if (!nav || !ul) return;

    // Ensure/insert "More"
    let more = ul.querySelector('.nav-more');
    if (!more) {
      more = document.createElement('li');
      more.className = 'list-menu__item nav-more';
      more.hidden = true;
      more.innerHTML = `
        <details class="header__menu-item">
          <summary class="header__menu-item list-menu__item link focus-inset" aria-haspopup="menu">
            More <span class="icon-caret" aria-hidden="true"></span>
          </summary>
          <ul class="header__submenu list-menu list-menu--disclosure" role="list" tabindex="-1" aria-label="More"></ul>
        </details>`;
      ul.appendChild(more);
    }
    const moreMenu = more.querySelector('ul');

    // Save original order once
    [...ul.children].forEach((li, i) => {
      if (li !== more && !li.dataset.originalIndex) li.dataset.originalIndex = i;
    });

    const moveToMore = (li) => moreMenu.appendChild(li);
    const restoreOne = (li) => {
      const idx = +li.dataset.originalIndex;
      const siblings = [...ul.children].filter(x => x !== more);
      const ref = siblings.find(x => +x.dataset.originalIndex > idx);
      ul.insertBefore(li, ref || more);
    };
    const restoreAll = () => {
      [...moreMenu.children]
        .sort((a,b)=>+a.dataset.originalIndex-+b.dataset.originalIndex)
        .forEach(restoreOne);
    };

    function measureMoreWidth(){
      const prevH = more.hidden, prevV = more.style.visibility;
      more.hidden = false; more.style.visibility = 'hidden';
      const w = Math.max(48, more.getBoundingClientRect().width);
      more.hidden = prevH; more.style.visibility = prevV;
      return w;
    }

    function navUsedWidth(){
      // Real width of the menu bar = extent of the visible <li> summaries.
      // Uses the items' own bounding boxes (NOT ul.scrollWidth), so an open mega
      // panel (position:absolute, out of flow) never inflates the measurement and
      // never triggers a false overflow that sweeps items into "More".
      const vis = [...ul.children].filter(li => li !== more);
      if (!vis.length) return 0;
      const first = vis[0].getBoundingClientRect();
      const last  = vis[vis.length - 1].getBoundingClientRect();
      return last.right - first.left;
    }

    function fits(reserved=0){
      return navUsedWidth() <= (nav.clientWidth - reserved - BUFFER);
    }

    function pack(){
      if (window.innerWidth < DESKTOP){
        restoreAll();
        more.hidden = true;
        return;
      }

      // Start clean on desktop
      restoreAll();
      more.hidden = true;

      // PASS 1: try without "More"
      if (fits(0)) return; // everything fits on high-res: keep More hidden

      // PASS 2: reserve "More" width and move rightmost items until it fits
      const reserved = measureMoreWidth();
      let guard = 50;

      while (!fits(reserved) && guard--) {
        const candidates = [...ul.children].filter(li => li !== more);
        const last = candidates[candidates.length - 1];
        if (!last) break;
        moveToMore(last);
      }

      // Try to bring items back if there is space (keep order)
      guard = 50;
      while (moreMenu.children.length && guard--) {
        const first = moreMenu.children[0];
        restoreOne(first);
        if (!fits(reserved)) { moveToMore(first); break; }
      }

      more.hidden = moreMenu.children.length === 0;
    }

    // The nav starts visibility:hidden via CSS (html.js:not(.nav-ready)) so the
    // cold-load repacks below don't produce a visible horizontal shift (CLS).
    // Reveal it once it has been packed with real font metrics.
    let revealed = false;
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      document.documentElement.classList.add('nav-ready');
    };

    // Run after layout is truly stable
    const runStable = () => {
      // wait two animation frames after load to let webfonts/search resize settle
      requestAnimationFrame(() => requestAnimationFrame(pack));
    };
    // Pack, then reveal on the following frames (so reveal lands after pack repositions).
    const packAndReveal = () => {
      runStable();
      requestAnimationFrame(() => requestAnimationFrame(reveal));
    };

    // Observe width changes (these fire during load while the nav is still hidden)
    const ro = new ResizeObserver(runStable);
    ro.observe(nav);

    // Theme editor hooks
    document.addEventListener('shopify:section:load', runStable);
    document.addEventListener('shopify:section:reorder', runStable);

    // Initial runs — reveal once fonts are settled (preferred) or on load
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(packAndReveal);
    }
    window.addEventListener('load', packAndReveal);
    // Pack early (still hidden) so the final reveal has minimal work to do
    document.addEventListener('DOMContentLoaded', runStable);
    // Safety: never leave the nav hidden if the above stall (e.g. fonts API missing).
    setTimeout(reveal, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();